import { Component, OnInit, Input } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { ConstructionService } from '@app/cp/shared/services/construction.service';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { ConstructionSearchParam } from '@app/cp/shared/models/ConstructionSearchParam';
import { GroupDescriptor, DataResult, process, State } from '@progress/kendo-data-query';
import { aggregateBy } from '@progress/kendo-data-query';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { DataStateChangeEvent } from '@progress/kendo-angular-grid';

@Component({
    selector: 'job-summary',
    templateUrl: './job-summary.component.html',
    styleUrls: ['./job-summary.component.scss']
})
export class JobSummaryComponent implements OnInit {

    constructor(private globals: GlobalsService, private svc_construction: ConstructionService, private svc_dispatch: DispatchesService) {
        //this.aggregates = [
        //    { field: 'bidSale', aggregate: 'sum' },
        //    { field: 'bidCost', aggregate: 'sum' },
        //    { field: 'jobCost', aggregate: 'sum' },
        //    { field: 'bidLabHrs', aggregate: 'sum' },
        //    { field: 'jobLabHrs', aggregate: 'sum' }
        //];
    }

    readOnly: boolean = false;

    @Input() contractId: string;
    @Input() summaryData: any = [];

    summaryDataNew: any = [];
    responseData: any;

    processedData: any = [];

    public aggregates: any[] = [
        { field: 'bidSale', aggregate: 'sum' },
        { field: 'bidCost', aggregate: 'sum' },
        { field: 'jobCost', aggregate: 'sum' },
        { field: 'bidLabHrs', aggregate: 'sum' },
        { field: 'jobLabHrs', aggregate: 'sum' }
    ];
    public aggregateResults;

    public state: State = {
        //skip: 0,
        //take: 5,
        group: [{ field: 'relatedJobType', aggregates: this.aggregates }]
    };

    public groups: GroupDescriptor[] = [{ field: 'relatedJobType' }];

    public gridData: DataResult;

    constSearchParam: ConstructionSearchParam = new ConstructionSearchParam();

    ngOnInit() {
        if (this.contractId) {
            this.constSearchParam.contractId = this.contractId;
            this.svc_construction.GetJobSummaryByContractId(this.constSearchParam).subscribe(data => {
                if (data && data.primaryReturn && data.primaryReturn.length > 0 && !data.warning) {
                    this.responseData = data.primaryReturn;
                    this.summaryDataNew = this.responseData;

                    this.loadLines();
                }
                if (this.responseData && this.responseData.warning) {
                    //alert('got an error back!');
                }
            });
        }
    }

    public groupChange(groups: GroupDescriptor[]): void {
        this.groups = groups;
        this.loadLines();
    }

    private loadLines(): void {
        this.gridData = process(this.summaryDataNew, this.state);  // { group: this.groups });
        //this.dataStateChange(null);
        this.processGridData();
    }

    processGridData() {
        if (CommonFunctions.hasArrayElementValue(this.gridData.data)) {
            this.aggregateResults = aggregateBy(this.summaryDataNew, this.aggregates);

        }
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        if (state && state.group) {
            state.group.map(group => group.aggregates = this.aggregates);
        }

        this.state = state;

        this.gridData = process(this.gridData.data, this.state);

    }

}
